export default {
  footer_title: {
    id: 'hc_footer_need_help',
    defaultMessage: 'Still need help?',
  },
  footer_instructions: {
    id: 'hc_footer_need_help_instructions',
    defaultMessage:
      'To get in touch about an order go to "Orders" and select "Get help" next to the one in question. We\'ll get back to you within 1 business day.',
  },
  footer_late_response_rate: {
    id: 'hc_footer_lrr',
    defaultMessage:
      'Our agents are busier than usual, so replies may take longer.',
  },
  footer_instructions_cta: {
    id: 'hc_footer_need_help_go_to_order_cta',
    defaultMessage: 'Get help with an order',
  },
  footer_need_help_cta: {
    id: 'hc_footer_messenger_intro',
    defaultMessage: 'For anything else, {cta, html}.',
  },
  footer_need_help_cta_link: {
    id: 'hc_footer_messenger_cta',
    defaultMessage: 'message us here',
  },
} as const
